import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('sassoontoken'); 
    navigate('/login');  // Navigate to the login page first
  };

  const handleLogoClick = () => {
    // handle logo click
    navigate('/');
  };

  return (
    <header className="header">
      <div className="header_empty"></div>
      <h1 className="logo" onClick={handleLogoClick}>
        <img 
          src="/images/sassoon-academy-logo.svg" 
          alt="logo" 
          className="logo-image" 
        />
      </h1>
      <button className="logout" onClick={handleLogout}>
        <i className='bx bx-log-out logout-icon'></i>
        <span className="logout-text">Logout</span>
      </button>
    </header>
  );
};

export default Header;
